import React from 'react';
import { Text } from '@srcDS/js/components/typography/text/Text';
import Tooltip from '@srcDS/js/components/atoms/tooltip';
import { InformationIcon } from '@srcDS/js/components/atoms/icons';
import styles from '../ProductActions.module.scss';

const FitslugComponent = ({ fitslug, fitdescription }) => {
  return (
    <div className={styles.tooltipBlock}>
      <div className={styles.tooltipTextBlock}>
        <Text className={styles.tooltipSideTextRight} as="span">
          {typeof fitslug === 'string' ? fitslug : fitslug?.label}
        </Text>
      </div>

      {fitdescription && (
        <Tooltip
          content={fitdescription}
          preferredPosition="top"
          preferredAlign="start"
        >
          <InformationIcon width={15} height={15} />
        </Tooltip>
      )}
    </div>
  );
};

export default FitslugComponent;
